import dataLayerSearch from 'assets/core/js/module/searchForm/dataLayer/search'
import selects from 'assets/core/js/module/searchForm/selects'
import autocomplete from 'assets/themes/vacances-campings/js/module/searchForm/autocomplete'
import calendar from 'assets/themes/vacances-campings/js/module/searchForm/calendar'
import events from 'assets/themes/vacances-campings/js/module/searchForm/events'
import maxDistance from 'assets/themes/vacances-campings/js/module/searchForm/maxDistance'
import menus from 'assets/themes/vacances-campings/js/module/searchForm/menus'

export default function (): void {
  const calendarInstance = calendar()
  const autocompleteInstance = autocomplete()
  selects()
  events()
  menus()
  maxDistance()
  const capacityInstance = (document.getElementById('search_offers_capacity') as HTMLSelectElement | null) ?? undefined

  dataLayerSearch(autocompleteInstance, calendarInstance, undefined, capacityInstance)
}
